import BaseAPI from "../base/BaseAPI.js";
import BaseAPIConfig from "@/apis/base/BaseAPIConfig.js";
import store from "@/stores/store";

class SystemAPI extends BaseAPI {
  constructor() {
    super();
    this.controller = "user";
  }

  getAllEmployee() {
    return BaseAPIConfig.get(this.controller + "/employee");
  }
  /**
   * Lấy thông tin user hiện tại
   * Createdby PHQuan 21/12/2020
   */
  getCurrentUser() {
    return new Promise((resolve, reject) => {
      BaseAPIConfig.get(`${this.controller}/app-data`)
        .then(res => {
          // if (res && res.data.Success) {
          store.dispatch("updateUserInfor", res.data.Data);
          store.dispatch("setUserOptions", res.data.Data.UserOptions);
          store.dispatch(
            "setListRole",
            res.data.Data.Permissions[`PROCESS_Permission`]
          );
            if (res.data.Data.Permissions[`PROCESS_Permission`]) {
              localStorage.setItem(
                "PROCESS_Permission",
                JSON.stringify(res.data.Data.Permissions[`PROCESS_Permission`])
              );
            }

            if (res.data.Data.UserData) {
              localStorage.setItem(
                "UserData",
                JSON.stringify(res.data.Data.UserData)
              );
            }

          //   // Nếu APChat chưa được khai báo file load thư viện JS
          //   // hoặc file thư viện load về không được(thiếu cdn, cdn lỗi...), đoạn code này sẽ văng lỗi
          //   if (
          //     res.data.Data.IsInstallAmisChat &&
          //     AMISChat &&
          //     AMISChat.Fn &&
          //     AMISChat.Fn.initAPChatBox
          //   ) {
          //     AMISChat.Fn.initAPChatBox();
          //   }
          // }
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  /**
   * Lưu useroption theo người dùng
   * @param {*} option
   * createdby pqmai 5/1/2020
   */
  saveUserOption(option) {
    return BaseAPIConfig.post(`${this.controller}/saveUserOption`, option);
  }

  /***
   * Xử lý đồng bộ CCTC từ Platform
   * Created by: LPLONG - 13/01/2021
   */
  syncOrganizationUnit() {
    return BaseAPIConfig.get(this.controller + "/organization-unit");
  }

  /**
   * Hàm lấy dữ liệu nhân viên từ hệ thống về
   * created by pqmai 16/3/2021
   */
  syncEmployee() {
    return BaseAPIConfig.get(this.controller + "/employee");
  }

  /**
   * Hàm lấy dữ liệu vị trí công việc từ hệ thống về
   * created by pqmai 16/3/2021
   */
  syncJobposition() {
    return BaseAPIConfig.get(this.controller + "/jobposition");
  }

  /**
   * Lấy danh sách CCTC và nhân sự HR của CCTC đó
   * @param {} data
   */
  async getUsermanagepayroll(data) {
    return BaseAPIConfig.post(`${this.controller}/get-usermanagepayroll`, data);
  }
}

export default new SystemAPI();
